import { useTranslation } from 'react-i18next';
import { ContractOrderOutputDto, UserDto } from '@api/client';
import OrderDataStatic from './order-data-static';
import { Modal as AntModal, Tooltip } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OrderDataEdit from './order-data-edit';
import { Accordion, Card, Col } from 'react-bootstrap';
import { useAppDispatch } from 'core/store/hooks';
import { deleteOrder } from 'pages/private/passive-cycle/_redux/actions';
import { AppToastService } from 'shared/design-system/components/app-toast/app-toast.service';
import { PathEnum } from 'core/router/path.enum';

interface Props {
  order: ContractOrderOutputDto;
  allUsers: UserDto[] | null;
}

const OrderData: React.FC<Props> = ({ order, allUsers }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [editMode, setEditMode] = useState(false);
  const [isOpened, setIsOpened] = useState<boolean>(true);

  const hasAssociations = (order.projectExternalCost?.length ?? 0) > 0;

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (hasAssociations) {
      AppToastService.error(
        t('Impossibile eliminare l\'ordine: sono presenti costi o progetti associati. Disassocia prima costi e progetti.'),
      );
      return;
    }
    AntModal.confirm({
      title: t('Conferma eliminazione'),
      content: t('Sei sicuro di voler eliminare questo ordine?'),
      okText: t('Elimina'),
      okType: 'danger',
      cancelText: t('common.cancel'),
      onOk: () => {
        if (!order.id) return;
        return dispatch(deleteOrder(order.id))
          .unwrap()
          .then((deletedId) => {
            if (deletedId != null) {
              AppToastService.success(t('Ordine eliminato con successo'));
              navigate(`/${PathEnum.PRIVATE}/${PathEnum.CICLO_PASSIVO}`);
            }
          });
      },
    });
  };

  const HeaderElement = (
    <div className="d-flex align-items-center">
      <Tooltip placement="top" title="Edit" color="teal">
        <button
          onClick={(e) => {
            e.stopPropagation();
            setIsOpened(true);
            setEditMode(!editMode);
          }}
          className="btn-icon"
          style={{ height: '25px' }}
        >
          <i className={'icon-edit text-teal-links me-1'} />
        </button>
      </Tooltip>
      <Tooltip placement="top" title={t('Elimina')} color="red">
        <button
          onClick={handleDelete}
          className="btn-icon"
          style={{ height: '25px' }}
        >
          <i className={'icon-delete'} style={{ color: 'red' }} />
        </button>
      </Tooltip>
    </div>
  );

  return (
    <Accordion activeKey={isOpened ? '0' : ''} className="acc-btn my-3">
      <Card className="border-left-primary acc-btn">
        <Card.Header
          className={`d-flex justify-content-between align-items-center cursor-pointer ${
            isOpened ? 'card-header-border' : ''
          } headerCard `}
          onClick={() => setIsOpened(!isOpened)}
        >
          <Col sm="auto">
            <b className="text-blue-links align-items-center my-auto me-3">{t('Order data')}</b>
          </Col>
          <div className="d-flex justify-content-end align-items-center">
            <>{HeaderElement}</>
            <div>
              <i
                className={` fa-solid fa-chevron-${isOpened ? 'up' : 'down'} `}
                style={{ textAlign: 'right', width: '20px' }}
              />
            </div>
          </div>
        </Card.Header>
        {isOpened && (
          <Card.Body className="mx-2">
            {editMode ? (
              <OrderDataEdit order={order} allUsers={allUsers} setEditMode={setEditMode} />
            ) : (
              <OrderDataStatic order={order} allUsers={allUsers} />
            )}
          </Card.Body>
        )}
      </Card>
    </Accordion>
  );
};

export default OrderData;
